// Season analytics event collection (CW2-648)

export enum AnalyticsEventType {
  APP_OPEN = 'app_open',
  REGISTRATION_STEP = 'registration_step',
  REGISTRATION_ERROR = 'registration_error',
  SHARE_CLICK = 'share_click',
  SHOP_NOW_CLICK = 'shop_now_click',
  A2HS_PROMPT_SHOWN = 'a2hs_prompt_shown',
  A2HS_CLICKED = 'a2hs_clicked',
  A2HS_INSTALLED = 'a2hs_installed',
}

export type AppOpenEntry = 'push' | 'standalone' | 'auth_link' | 'browser'

export type ShareChannel = 'text' | 'email' | 'facebook' | 'copy' | 'qr'

export type ShareMethod = 'native' | 'self_text' | 'form_send'

// Stamped by AnalyticsService.track on EVERY event (§4.1): whether the app runs as an installed
// (standalone) PWA. app_open resolves it itself (async, with the 3 s A2HS timeout) and its value
// wins; every other event gets the synchronous resolution at fire time.
export interface StandaloneContext {
  isStandalone?: boolean
}

export interface AppOpenPayload extends StandaloneContext {
  isStandalone: boolean
  entry: AppOpenEntry
  gapSeconds: number | null
}

export interface RegistrationStepPayload extends StandaloneContext {
  step: 'teacher' | 'photo'
}

export interface RegistrationErrorPayload extends StandaloneContext {
  step: string
  reason: string
  source: 'client'
}

export interface ShareClickPayload extends StandaloneContext {
  channel: ShareChannel
  method?: ShareMethod
}

export type AnalyticsEventPayload =
  | AppOpenPayload
  | RegistrationStepPayload
  | RegistrationErrorPayload
  | ShareClickPayload

export interface QueuedAnalyticsEvent {
  uid: string
  type: AnalyticsEventType
  // never null once queued: at minimum { isStandalone }
  payload: AnalyticsEventPayload | StandaloneContext
  occurredAt: string
}
